import { Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";
import HtmlParse from "html-react-parser";
import Types from "prop-types";
import * as React from "react";

const BootstrapDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paperWidthSm": {
    borderRadius: "15px",
    margin: "10px",
    width: "600px",
  },
}));

export default function ModalCustom({
  title = "",
  open,
  handleClose,
  children,
  className = "",
  titleSx = "",
  sx = "",
}) {
  return (
    <div>
      <BootstrapDialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={sx}
      >
        {title && (
          <DialogTitle id="alert-dialog-title" sx={{ padding: "16px" }}>
            <Typography className="text-popup jvs-f16 text-center" sx={titleSx}>
              {HtmlParse(title)}
            </Typography>
          </DialogTitle>
        )}
        <DialogContent className={className}>{children}</DialogContent>
      </BootstrapDialog>
    </div>
  );
}

ModalCustom.propTypes = {
  title: Types.string,
  open: Types.bool,
  handleClose: Types.func,
  children: Types.node,
  className: Types.string,
  titleSx: Types.objectOf(Object),
  sx: Types.objectOf(Object),
};
